/**
 * RoadmapButton — sidebar button that asks Mr Pibb to show the data roadmap.
 * Clicking it sends a fixed prompt (ROADMAP_PROMPT) into the current
 * conversation, so the Milestone Summary table renders inline via the normal
 * chat pipeline and the user can ask follow-up questions in the same thread.
 * Presentational only: the caller owns the send behavior via `onSend`.
 */
import React from 'react';
import { ROADMAP_BUTTON_LABEL } from './common/constants';

interface RoadmapButtonProps {
  /** Invoked on click; the caller wires this to send ROADMAP_PROMPT. */
  onSend: () => void;
}

/**
 * Renders the roadmap button (ROADMAP_BUTTON_LABEL) that triggers the roadmap prompt.
 */
export function RoadmapButton({ onSend }: RoadmapButtonProps): React.ReactElement {
  // Matches FeedbackButton's sidebar button dimensions; distinct teal fill
  // sets it apart from the purple Feedback and red Logout buttons.
  const buttonStyle: React.CSSProperties = {
    width: '100%',
    padding: '6px 12px',
    marginBottom: '8px',
    backgroundColor: '#00897b',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  };

  return (
    <button
      onClick={onSend}
      style={buttonStyle}
      title="See the data roadmap — what Mr Pibb can answer today and what's coming"
    >
      {ROADMAP_BUTTON_LABEL}
    </button>
  );
}
